import React, { useState } from "react";

const DropdownCountry = ({
	label,
	labelFor,
	options,
	value,
	setVal = (v) => {},
	memberId,
}) => {
	const [selectedOption, setSelectedOption] = useState(value);

	const handleSelectChange = (event) => {
		setSelectedOption(event.target.value);
		setVal(event.target.value);
	};

	return (
		<div style={{ position: "relative" }}>
			<div style={{ position: "relative", zIndex: "2" }}>
				{label && (
					<label
						htmlFor={labelFor}
						style={{ color: "black", fontSize: "12px" }}
					>
						{label}
					</label>
				)}
				<select
					className="form-select form-select-lg"
					aria-label=".form-select-lg"
					id={labelFor}
					value={selectedOption}
					onChange={handleSelectChange}
					style={{
						fontWeight: selectedOption ? "700" : "300",
						color: selectedOption ? "black" : "#A7A7A7",
					}}
					disabled={memberId ? true : false}
				>
					<option value="" disabled>
						Select {label} (Option)
					</option>
					{options.map((option, index) => (
						<option key={index} value={option.country_name}>
							{option.country_name}
						</option>
					))}
				</select>
			</div>
			<img
				src="./img/icon/dropdown-icon.png"
				alt=""
				className="dropdown-icon-style"
			/>
		</div>
	);
};

export default DropdownCountry;
